<template>
  <v-overlay :value="open" opacity="1" color="#0e0e0e" class="fullscreen-menu">
    <v-container fluid class="fill-height" @mousemove="onMouseMove" @mouseout="onMouseOut">
      <v-row no-gutters class="scrolling-row px-5" justify="space-between" :style="horizontalTiltTransform">
        <v-col
          v-for="(menu, index) in $root.siteSettings.menu"
          :key="'menu'+index"
          cols="12"
          md="auto"
          class="my-2 my-md-3 item"
          :class="{'ml-md-12 ': index === 0, 'mr-md-12': index === menu.length-1, 'disabled': !menu.enabled, 'inactive': indexrollover !== index && indexrollover > -1}"
          @mouseover="menu.target !== '' ? indexrollover = index : null"
          @mouseout="indexrollover = -1"
          @click="onClick({'name': menu.target})"
          >
          <h1>{{menu.label}}</h1>
          <h5 v-if="menu.subtitle && menu.subtitle !== ''">{{menu.subtitle}}</h5>
        </v-col>
      </v-row>
    </v-container>

    <div class="language-selector pr-3 pb-3 pr-md-6 pb-md-6">
      <span @click="onLanguageClick(lang)" v-for="lang in availableLanguage" :key="lang">
        {{lang}}
      </span>
    </div>
  </v-overlay>
</template>

<script>
import { Viewport } from '@monogrid/vue-lib'
import { NumberUtils, RAF, ElasticNumber } from '@monogrid/js-utils'

export default {
  name: 'FullscreenMenu',

  mixins: [Viewport],

  props: {
    open: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      movementX: new ElasticNumber(0),
      prevTime: 0,
      indexrollover: -1
    }
  },

  mounted () {
    this.movementX.speed = 5
    RAF.add(this.render)
    console.log('open')
  },

  destroyed () {
    RAF.remove(this.render)
  },

  watch: {
    // whenever question changes, this function will run
    open: function (value) {
      if (value) {
        console.log('open')
        this.movementX.target = 0
        this.movementX.value = 0
        RAF.add(this.render)
      } else {
        console.log('close')
        RAF.remove(this.render)
      }
    }
  },
  methods: {
    onLanguageClick (lang) {
      this.$root.siteSettings = this.$root.allSiteSettings[lang]
      this.$router.push({ params: { language: lang } })
    },

    onClick (params) {
      if (params.name === this.$route.name) {
        if (params.name === 'Scenario') {
          this.$router.push({ name: 'Scenario', route: 'Scenario', params: { scenarioSlug: null } })
        }
        this.$emit('menu:close')
      } else {
        this.$router.push(params)
      }
    },

    render () {
      const now = new Date().getTime()
      let delta = (now - this.prevTime) / 1000
      delta = 1 / 180 // Mat

      this.movementX.update(delta)
    },

    onMouseOut (e) {
      // this.movementX.target = 0.5
    },

    onMouseMove (e) {
      if (this.$vuetify.breakpoint.smAndUp) {
        this.movementX.target = e.clientX / this.viewPort.width
      } else {
        this.movementX.value = 0
      }
    }
  },

  computed: {
    menu () {
      const menu = []
      this.$root.siteSettings.menu.forEach(element => {
        menu.push({
          route: element.target
        })
      })
      return menu
    },
    availableLanguage () {
      const langs = []
      for (const key in this.$language.available) {
        if (key !== this.$language.current) {
          langs.push(key)
        }
      }
      return langs
    },

    horizontalTiltTransform () {
      let lerpLimit = 0

      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          lerpLimit = 0
          break
        case 'sm':
          lerpLimit = 0
          break
        case 'md':
          lerpLimit = 110
          break
        case 'lg':
          lerpLimit = 110
          break
        case 'xl':
          lerpLimit = 40
          break
      }

      return {
        transform: (this.$vuetify.breakpoint.smAndUp) ? 'translate3d(' + NumberUtils.lerpNumber(lerpLimit, -lerpLimit, this.movementX.value) + 'vw, 0, 0)' : 'none'
      }
    }
  }
}
</script>

<style scoped lang="scss">

.fullscreen-menu {
  height: 100vh;
}

.container {
  width: auto;

  @include breakpoint('md-only') {
    width: 240vw;
  }

  @include breakpoint('lg-only') {
    width: 230vw;
  }

  @include breakpoint('xl-only') {
    width: 150vw;
  }
}

.scrolling-row {
  backface-visibility: hidden;
}

h3 {
  font-family: Barlow;
  font-size: 40px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: inherit;
}

h5 {
  color: $c-red;
  font-family: Lora;
  font-weight: normal;
  font-size: 12px;

  @include breakpoint('sm-and-up') {
    opacity: 0;
    font-size: 16px;
    transition: opacity 0.3s ease-out;
  }

  &::before {
    content: '—';
    display: inline-block;

    margin-right: 5px;
  }
}

.item {
  cursor: pointer;
  transition: opacity 0.2s;
  opacity: 1;

  &:hover {
    h5 {
      opacity: 1;
    }
  }

  &.disabled {
    cursor: auto;
    opacity: 0.2;
  }

  &.inactive {
    opacity: 0.2;
  }
}

.language-selector {
  // display: none;
  position: fixed;
  bottom: 12px;
  right: 12px;
  cursor: pointer;
  transition: opacity 0.5s;

  span {
    font-family: Barlow;
    text-transform: uppercase;
  }
}
</style>
